module.exports = __webpack_public_path__ + "img/product1.9d18b691.png";